import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';

export const getAlertNotificationStatusFromAppConfig = async () => {
  const urlBuilder = createUrlBuilder('/getNotificationBannerStatus');
  const result = await getRequest(LocateService, urlBuilder.toString());
  return result?.data;
};
